import app from "app/App/reducer";
import me from "app/Me/reducer";

const exportObject = {
	app,
	me
};

export default exportObject;